import { render, staticRenderFns } from "./commercial-broad.vue?vue&type=template&id=bc8976f2&"
import script from "./commercial-broad.vue?vue&type=script&lang=js&"
export * from "./commercial-broad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc8976f2')) {
      api.createRecord('bc8976f2', component.options)
    } else {
      api.reload('bc8976f2', component.options)
    }
    module.hot.accept("./commercial-broad.vue?vue&type=template&id=bc8976f2&", function () {
      api.rerender('bc8976f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion-2023/commercial-broad.vue"
export default component.exports